export const validateDate = (value: string) => {
  const dateRegex = /^\d{2}\.\d{2}\.\d{4}$/;
  return dateRegex.test(value);
};

export const formatNumber = (num: number): string => {
  if (num >= 100_000) {
    return `${Math.floor(num / 1000)}K`;
  }
  return num.toString();
};
